module.exports = __webpack_public_path__ + "img/FAQ_Asset.31e4d2b4.svg";